import { getText } from 'i18n/intl';

type TMinMaxValidation = {
  min?: number;
  max?: number;
};
export const validateNumber = (
  number?: number,
  { min, max }: TMinMaxValidation = {}
) => {
  if (Number.isNaN(Number(number))) return false;
  if (min === undefined && max === undefined) return true;
  if (min === undefined) return Number(number) < Number(max);
  if (max === undefined) return Number(number) > Number(min);
  return true;
};

type FormValidatePattern = {
  pattern: RegExp;
};

type FormValidateRequired = {
  required: boolean;
};

type FormValidateType = {
  type: RuleType;
};

type RuleType =
  | 'string'
  | 'number'
  | 'boolean'
  | 'method'
  | 'regexp'
  | 'integer'
  | 'float'
  | 'object'
  | 'enum'
  | 'date'
  | 'url'
  | 'hex'
  | 'email';

export type FormValidationRule = {
  message: string;
} & (FormValidatePattern | FormValidateRequired | FormValidateType);

const looseUuidRegex =
  /^[0-9A-F]{8}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{4}-[0-9A-F]{12}$/i;

export const emailPatternValidationRule: FormValidationRule = {
  type: 'email',
  message: getText('form.validation_error.email_pattern'),
};

export const looseUuidPatternValidationRule: FormValidationRule = {
  pattern: looseUuidRegex,
  message: getText('form.validation_error.guid_pattern'),
};

export const requiredValidationRule: FormValidationRule = {
  required: true,
  message: getText('form.validation_error.required'),
};
